import mixpanel from 'mixpanel-browser';

export const mixpanelTrack = (eventName: string, eventProps?: {}) => {
    mixpanel.track(eventName, eventProps);
};

export function mixpanelIdentify(id: string) {
    mixpanel.identify(id);
}

export function mixpanelSetPerson(data: { userId?: string, email?: string, firstName?: string, lastName?: string, createdAt?: string }) {
    mixpanel.people.set({
        id: data.userId,
        $email: data.email,
        $first_name: data.firstName,
        $last_name: data.lastName,
        $created: data.createdAt
    });
}